var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "printerCard" },
    [
      _c(
        "div",
        {
          staticClass: "cardContainer",
          on: {
            click: function ($event) {
              return _vm.handleItem(_vm.info)
            },
          },
        },
        [
          _c("div", { staticClass: "conLeft" }, [
            _c("img", { staticClass: "leftImg", attrs: { src: _vm.info.img } }),
          ]),
          _c("div", { staticClass: "conRight" }, [
            _c("div", { staticClass: "pName" }, [
              _c("div", { staticClass: "nameLeft" }, [
                _c(
                  "div",
                  { staticClass: "name", attrs: { title: _vm.info.name } },
                  [_vm._v(_vm._s(_vm.info.name))]
                ),
              ]),
              _c("div", { staticClass: "nameRight" }),
            ]),
            _c("div", { staticClass: "labels" }, [
              _c(
                "div",
                {
                  class:
                    _vm.info.status == "busy"
                      ? "busy"
                      : _vm.info.status == "free"
                      ? "free"
                      : "offline",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.info.status == "busy"
                          ? "Busy"
                          : _vm.info.status == "free"
                          ? "Free"
                          : "Offline"
                      ) +
                      " "
                  ),
                ]
              ),
              _vm._m(0),
            ]),
            _c("div", { staticClass: "pModel" }, [
              _c("span", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("MachineModel"))),
              ]),
              _c("span", { staticClass: "val" }, [
                _vm._v(_vm._s(_vm.info.model)),
              ]),
            ]),
            _c("div", { staticClass: "pCn" }, [
              _c("span", { staticClass: "label" }, [_vm._v("IP")]),
              _c("span", { staticClass: "val" }, [_vm._v(_vm._s(_vm.info.ip))]),
            ]),
            _c("div", { staticClass: "pFirmware" }, [
              _c("div", { staticClass: "left" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("FirmwareVersion"))),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "val",
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", [
                      _vm._v(_vm._s(_vm.info.version?.firmware_version)),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm.isOnline
              ? _c(
                  "div",
                  { staticClass: "more" },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          width: "146",
                          trigger: "click",
                          "append-to-body": false,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handlePopoverClick.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "operate" }, [
                          _c(
                            "div",
                            {
                              staticClass: "item",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleRename.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Rename")) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "item",
                              staticStyle: { color: "var(--warn-text-color)" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deletePrinter.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("delete")) + " ")]
                          ),
                        ]),
                        _c(
                          "span",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _c("img", {
                              staticClass: "more-icon",
                              attrs: { src: _vm.getDarkIcon("more") },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm.info && _vm.info.project
        ? _c("div", { staticClass: "task" }, [
            _c("div", { staticClass: "taskInfo" }, [
              _c("div", { staticClass: "infoLeft" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.formmatLabel(_vm.info?.project.print_status)) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "infoRight" }, [
                _c("span", { staticClass: "layer" }, [
                  _vm._v(
                    _vm._s(_vm.info?.project.curr_layer) +
                      "/" +
                      _vm._s(_vm.info?.project.total_layers)
                  ),
                ]),
                _c("span", { staticClass: "time" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$common.formatSeconds(
                        parseInt(_vm.info?.project.remain_time) * 60
                      )
                    )
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "taskProgress" }, [
              _c("div", { staticClass: "progress" }, [
                _c("div", {
                  staticClass: "fill",
                  style: { width: `${_vm.info.project.progress}%` },
                }),
              ]),
            ]),
            _c("div", { staticClass: "consumeInfo" }, [
              _c("div", { staticClass: "infoLeft" }, [
                _vm._v(_vm._s(_vm.info.project.progress) + "%"),
              ]),
              _vm.isOnline &&
              _vm.deviceOnline &&
              (_vm.info?.project.print_status == 1 ||
                _vm.info?.project.print_status == 6)
                ? _c("div", { staticClass: "infoRight" }, [
                    _c("div", { staticClass: "rightOp" }, [
                      _vm.getShow
                        ? _c(
                            "div",
                            {
                              staticClass: "opBox",
                              style: {
                                opacity:
                                  _vm.info.project.pause == "2" ||
                                  _vm.info.project.pause == "4"
                                    ? ".4"
                                    : "1",
                              },
                              on: { click: _vm.openInfo },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/imgs/skip.svg"),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "label",
                                  staticStyle: { color: "#3986ff" },
                                },
                                [_vm._v(_vm._s(_vm.$t("skip")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "rightOp" }, [
                      _vm.info.project.pause == "0"
                        ? _c(
                            "div",
                            {
                              staticClass: "opBox",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleOp("1")
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/imgs/icon-suspend.png"),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "label",
                                  staticStyle: { color: "#3986ff" },
                                },
                                [_vm._v(_vm._s(_vm.$t("Pause")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.info.project.pause == "2" ||
                      _vm.info.project.pause == "4"
                        ? _c("div", { staticClass: "opBox" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/icon-pausing.png"),
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  color: "rgba(57, 134, 255, 0.4)",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Pause")))]
                            ),
                          ])
                        : _vm._e(),
                      _vm.info.project.pause == "1"
                        ? _c(
                            "div",
                            {
                              staticClass: "opBox",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleOp("2")
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/imgs/icon-continue.png"),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "label",
                                  staticStyle: { color: "#3986ff" },
                                },
                                [_vm._v(_vm._s(_vm.$t("Resume")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.info.project.pause == "3"
                        ? _c("div", { staticClass: "opBox" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/icon-continuing.png"),
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  color: "rgba(57, 134, 255, 0.4)",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Resume")))]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "rightOver" }, [
                      _vm.info.project.pause == "0" ||
                      _vm.info.project.pause == "1"
                        ? _c(
                            "div",
                            {
                              staticClass: "opBox",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleOp("3")
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/imgs/icon-stop.png"),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "label",
                                  staticStyle: { color: "#ff4d4f" },
                                },
                                [_vm._v(_vm._s(_vm.$t("Stop")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.info.project.pause == "2" ||
                      _vm.info.project.pause == "3" ||
                      _vm.info.project.pause == "4"
                        ? _c("div", { staticClass: "opBox" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/icon-stoping.png"),
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  color: "rgba(255, 77, 79, 0.4)",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Stop")))]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _c("div", { staticClass: "infoRight" }, [
                    _c("div", { staticClass: "rightOp" }, [
                      _c("div", { staticClass: "opBox" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/imgs/icon-pausing.png"),
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "label",
                            staticStyle: { color: "rgba(57, 134, 255, 0.4)" },
                          },
                          [_vm._v(_vm._s(_vm.$t("Pause")))]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "rightOver" }, [
                      _c("div", { staticClass: "opBox" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/imgs/icon-stoping.png"),
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "label",
                            staticStyle: { color: "rgba(255, 77, 79, 0.4)" },
                          },
                          [_vm._v(_vm._s(_vm.$t("Stop")))]
                        ),
                      ]),
                    ]),
                  ]),
            ]),
          ])
        : _vm._e(),
      _vm.info &&
      !_vm.info.project &&
      (_vm.formmatUpdate() == "1" || _vm.formmatUpdate() == "2") &&
      _vm.isOnline &&
      _vm.deviceOnline
        ? _c(
            "div",
            {
              staticClass: "cardFooter",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleUpdate.apply(null, arguments)
                },
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.formmatUpdate() == "1"
                      ? _vm.$t("NewFirmwareAvailable")
                      : _vm.$t("FirmwareUpdating")
                  )
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("rename", {
        attrs: { visible: _vm.renameVisible, rename: _vm.info.name },
        on: {
          "update:visible": function ($event) {
            _vm.renameVisible = $event
          },
          changeName: _vm.changeName,
        },
      }),
      _c("moreInfo", {
        attrs: { visible: _vm.moreVisible, id: _vm.info.id },
        on: {
          "update:visible": function ($event) {
            _vm.moreVisible = $event
          },
        },
      }),
      _c("firmwareUpdate", {
        attrs: { visible: _vm.updateVisible, info: _vm.info },
        on: {
          "update:visible": function ($event) {
            _vm.updateVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lanInfo" }, [
      _c("img", { attrs: { src: require("@/assets/imgs/lanIcon.png") } }),
      _c("span", [_vm._v("LAN")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }